// extracted by mini-css-extract-plugin
export var spacing = "spacing-module--spacing--pgnU+";
export var withBorder = "spacing-module--withBorder--9AO-P";
export var spacingBlue = "spacing-module--spacingBlue---cVKx";
export var spacingMint = "spacing-module--spacingMint--vfR9M";
export var spacingWhite = "spacing-module--spacingWhite--jppmT";
export var spacingLight = "spacing-module--spacingLight--aYKVw";
export var spacingConcrete = "spacing-module--spacingConcrete--ciHoG";
export var spacingNeon = "spacing-module--spacingNeon--AKcGP";
export var blueColumn = "spacing-module--blueColumn--bFGLO";